export const SET_USER = 'SET_USER';
export const UPDATE_USER = 'UPDATE_USER';
export const SET_ORGANIZATION = 'SET_ORGANIZATION';
export const UPDATE_ORGANIZATION = 'UPDATE_ORGANIZATION';
export const SET_ORGANIZATION_USERS = 'SET_ORGANIZATION_USERS';
export const SET_LOADING = 'SET_LOADING';
export const SET_FORM = 'SET_FORM';
export const SET_STORAGE_SETTINGS = 'SET_STORAGE_SETTINGS';
